// "use client";
// import { showErrorToast, showSuccessToast } from "@/app/utils/toastConfig";
// import axios from "axios";
// import { useEffect, useState } from "react";
// import { useRouter } from 'next/navigation';
// import TextField from "@mui/material/TextField";
// import Button from "@mui/material/Button";
// import CircularProgress from "@mui/material/CircularProgress";
// import InputAdornment from "@mui/material/InputAdornment";
// import { FaUser, FaLock } from "react-icons/fa";
// import { ToastContainer } from "react-toastify";
// import { FaEye, FaEyeSlash } from "react-icons/fa";
// import { getFilteredMenuData } from "@/app/components/Sidebar/sidebar";
// import Alert from '@mui/material/Alert';
// import Collapse from '@mui/material/Collapse';
// import IconButton from '@mui/material/IconButton';
// import CloseIcon from '@mui/icons-material/Close';


// const LoginForm = () => {
//     const [userName, setUserName] = useState('');
//     const [password, setPassword] = useState('');
//     const [errors, setErrors] = useState<{ userName?: string; password?: string }>({});
//     const [loading, setLoading] = useState(false);
//     const [showPassword, setShowPassword] = useState(false);
//     const [alertOpen, setAlertOpen] = useState(false);
//     const [alertMessage, setAlertMessage] = useState('');
//     const [alertSeverity, setAlertSeverity] = useState<'success' | 'info' | 'warning' | 'error'>('info');
//     const [themeColor, setThemeColor] = useState("d72828");
//     const [confirmationOpen, setConfirmationOpen] = useState(false);
//     const [confirmationMessage, setConfirmationMessage] = useState("");
//     const [onConfirm, setOnConfirm] = useState<(() => void) | null>(null);
//     const router = useRouter();
//     const validate = () => {
//         const newErrors: { userName?: string; password?: string } = {};
//         if (!userName.trim()) newErrors.userName = 'Username is required';
//         if (!password.trim()) newErrors.password = 'Password is required';
//         // else if (password.length < 6) newErrors.password = 'Password must be at least 6 characters';
//         setErrors(newErrors);
//         return Object.keys(newErrors).length === 0;
//     };

//     useEffect(() => {
//         fetchLoginTheme();
//     }, []);

//     const fetchLoginTheme = async () => {
//         debugger
//         try {
//             debugger
//             const response = await axios.get(
//                 "/Services/UserService.svc/GetLoginTheme"
//             );
//             debugger
//             if (response.data?.ErrorCode === 200) {
//                 const rawData = response.data.Data;
//                 debugger
//                 const match = rawData.match(/ThemeColor:(.*)/);
//                 debugger
//                 if (match && match[1]) {
//                     setThemeColor(match[1].trim());
//                 }
//             }
//         } catch (error) {
//             console.error("Theme fetch error:", error);
//         }
//     };
//     const showMuiAlert = (message: string, severity: 'success' | 'info' | 'warning' | 'error') => {
//         setAlertMessage(message);
//         setAlertSeverity(severity);
//         setAlertOpen(true);
//     };

//     const showConfirmationDialog = (message: string, onConfirmCallback: () => void) => {
//         setConfirmationMessage(message);
//         setConfirmationOpen(true);
//         setOnConfirm(() => onConfirmCallback);
//     };

//     const handleSubmit = async (e: React.FormEvent) => {
//         e.preventDefault();
//         if (!validate()) return;
//         setLoading(true);
//         try {
//             localStorage.setItem('userName', userName);
//             const response = await axios.post("/Services/UserService.svc/LoginUser", {
//                 userName,
//                 password, type: "Login"
//             });
//             const responseData = response.data;
//             debugger
//             if (response.data.ErrorCode !== 200) {
//                 showErrorToast(`Login failed: ${response.data.Message || "Please try again later."}`);
//             } else {
//                 debugger
//                 const rawData = responseData.Data as string;

//                 const dataParts: Record<string, string> = {};

//                 const matches = rawData.match(/(\w+):(.*?)(?=,\s*\w+:|$)/g);

//                 matches?.forEach((item) => {
//                     const index = item.indexOf(":");
//                     const key = item.substring(0, index).trim();
//                     const value = item.substring(index + 1).trim();

//                     dataParts[key] = value;
//                 });
//                 debugger

//                 let resolvedUserType = "";
//                 if (dataParts.UserType === "Admin" || dataParts.UserType === "Processer" || dataParts.UserType === "Processor") {
//                     resolvedUserType = dataParts.UserType;
//                 } else if (dataParts.UserType === "User" && dataParts.Approver.length > 0) {
//                     resolvedUserType = "Requester";
//                 } else if (dataParts.UserType === "User") {
//                     resolvedUserType = "Approver";
//                 }

//                 localStorage.setItem("userType", resolvedUserType);
//                 localStorage.setItem("approver", dataParts.Approver);
//                 localStorage.setItem("maxofRec", dataParts.MaxofRec);
//                 localStorage.setItem("cardCode", dataParts.CardCode);
//                 localStorage.setItem("cardName", dataParts.CardName);
//                 localStorage.setItem("themeColor", dataParts.ThemeColor);
//                 debugger

//                 if (resolvedUserType === "Requester") {
//                     try {
//                         const responses = await axios.post('/Services/UserService.svc/TransServerClick', { userName });
//                         const result = responses.data;
//                         if (result !== null) {
//                             // Show confirmation dialog
//                             showConfirmationDialog(result.Data, () => {
//                                 showSuccessToast(responseData.Message);
//                                 const allowedMenus = getFilteredMenuData(resolvedUserType);
//                                 const firstPath = allowedMenus[0]?.subMenu?.[0]?.path;
//                                 router.push(firstPath);
//                                 setConfirmationOpen(false);
//                             });
//                         } else {
//                             showSuccessToast(responseData.Message);
//                             const allowedMenus = getFilteredMenuData(resolvedUserType);
//                             const firstPath = allowedMenus[0]?.subMenu?.[0]?.path;
//                             router.push(firstPath);
//                         }
//                     } catch (error) {
//                         console.error(error);
//                         showErrorToast("Something went wrong, please try again.");
//                     }
//                 } else {
//                     showSuccessToast(responseData.Message);
//                     const allowedMenus = getFilteredMenuData(resolvedUserType);
//                     const firstPath = allowedMenus[0]?.subMenu?.[0]?.path;
//                     router.push(firstPath);
//                 }

//             }
//         } catch (err) {
//             showErrorToast("Something went wrong. Please try again.");
//         } finally {
//             setLoading(false);
//         }
//     };

//     return (
//         // <div className="flex items-center justify-center min-h-screen bg-red-700">
//         <div
//             style={{
//                 // backgroundColor: "#37e88e"
//                 // background: "linear-gradient(90deg, #37e88e 0%, rgba(12, 179, 71, 0.98) 100%)",
//                 background: themeColor,
//             }}
//             className="flex items-center justify-center min-h-screen"
//         >
//             <form
//                 onSubmit={handleSubmit}
//                 className="w-full max-w-md p-10 bg-white rounded-2xl shadow-2xl"
//             >

//                 <div className="flex justify-center items-center">
//                     <img
//                         className="w-20 h-20"
//                         src="/SathyaLogo.png"
//                         alt="SATHYA"
//                         width={80}
//                         height={80}
//                     />
//                 </div>
//                 <h2 className="text-3xl font-bold text-center text-red-700 mb-8">User Login</h2>

//                 <div className="relative mb-6">
//                     {/* <FaUser className="absolute top-1/2 left-3 transform -translate-y-1/2 text-gray-600 text-lg z-10" /> */}
//                     <TextField
//                         fullWidth
//                         label="Username"
//                         variant="outlined"
//                         value={userName}
//                         onChange={(e) => setUserName(e.target.value)}
//                         error={!!errors.userName}
//                         helperText={errors.userName}
//                         InputProps={{
//                             startAdornment: (
//                                 <InputAdornment position="start">
//                                     <FaUser className="text-gray-600" />
//                                 </InputAdornment>
//                             ),
//                             style: { backgroundColor: "#ffffff" }, // white input field
//                         }}
//                     />
//                 </div>

//                 <div className="relative mb-6">

//                     <TextField
//                         fullWidth
//                         label="Password"
//                         type={showPassword ? "text" : "password"}
//                         variant="outlined"
//                         value={password}
//                         onChange={(e) => setPassword(e.target.value)}
//                         error={!!errors.password}
//                         helperText={errors.password}
//                         InputProps={{
//                             startAdornment: (
//                                 <InputAdornment position="start">
//                                     <FaLock className="text-gray-600" />
//                                 </InputAdornment>
//                             ),
//                             endAdornment: (
//                                 <InputAdornment position="end" onClick={() => setShowPassword(!showPassword)} style={{ cursor: "pointer" }}>
//                                     {showPassword ? <FaEye /> : <FaEyeSlash />}
//                                 </InputAdornment>
//                             ),
//                             style: { backgroundColor: "#ffffff" },
//                         }}
//                     />

//                 </div>

//                 <Button
//                     type="submit"
//                     variant="contained"
//                     fullWidth
//                     size="large"
//                     className="rounded-xl shadow-md"
//                     style={{
//                         background: themeColor,
//                     }}
//                     disabled={loading}
//                 >
//                     {loading ? <CircularProgress size={24} color="inherit" /> : "Login"}
//                 </Button>


//             </form>

//             {/* Confirmation Dialog */}
//             {confirmationOpen && (
//                 <div
//                     className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
//                     onClick={() => setConfirmationOpen(false)}
//                 >
//                     <div
//                         className="bg-white rounded p-6 w-[700px]"
//                         onClick={(e) => e.stopPropagation()}
//                     >
//                         <p className="mb-4">{confirmationMessage}</p>
//                         <div className="flex justify-end gap-4">
//                             <Button
//                                 variant="contained"
//                                 color="primary"
//                                 onClick={() => {
//                                     if (onConfirm) onConfirm();
//                                 }}
//                             >
//                                 OK
//                             </Button>
//                         </div>
//                     </div>
//                 </div>
//             )}
//             <ToastContainer />
//         </div>
//     );
// };

// export default LoginForm;


"use client";
import { showErrorToast, showSuccessToast } from "@/app/utils/toastConfig";
import axios from "axios";
import { useEffect, useState } from "react";
import { useRouter } from 'next/navigation';
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import InputAdornment from "@mui/material/InputAdornment";
import { FaUser, FaLock } from "react-icons/fa";
import { ToastContainer } from "react-toastify";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { getFilteredMenuData } from "@/app/components/Sidebar/sidebar";

type Step = 'username' | 'password' | 'otp';

const LoginForm = () => {
    const [step, setStep] = useState<Step>('username');
    const [userName, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [otp, setOtp] = useState('');
    const [errors, setErrors] = useState<{ userName?: string; password?: string; otp?: string }>({});
    const [loading, setLoading] = useState(false);
    const [otpLoading, setOtpLoading] = useState(false);
    const [resendLoading, setResendLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [themeColor, setThemeColor] = useState("d72828");
    const [confirmationOpen, setConfirmationOpen] = useState(false);
    const [confirmationMessage, setConfirmationMessage] = useState("");
    const [onConfirm, setOnConfirm] = useState<(() => void) | null>(null);

    const [pendingLogin, setPendingLogin] = useState<{
        resolvedUserType: string;
        responseData: any;
        userId: string;
        mobileNo: string;
    } | null>(null);

    const router = useRouter();

    useEffect(() => {
        fetchLoginTheme();
    }, []);

    const fetchLoginTheme = async () => {
        try {
            const response = await axios.get(
                "/Services/UserService.svc/GetLoginTheme"
            );
            if (response.data?.ErrorCode === 200) {
                const rawData = response.data.Data;
                const match = rawData.match(/ThemeColor:(.*)/);
                if (match && match[1]) {
                    setThemeColor(match[1].trim());
                }
            }
        } catch (error) {
            console.error("Theme fetch error:", error);
        }
    };

    const showConfirmationDialog = (message: string, onConfirmCallback: () => void) => {
        setConfirmationMessage(message);
        setConfirmationOpen(true);
        setOnConfirm(() => onConfirmCallback);
    };
    const getDeviceLocation = (): Promise<{
        lat: number;
        long: number;
        systemName: string;
    }> => {
        return new Promise((resolve, reject) => {
            const systemName = `${navigator.platform} - ${navigator.userAgent}`;

            if (!navigator.geolocation) {
                showErrorToast("Location is not supported by this browser.");
                reject(new Error("GEOLOCATION_NOT_SUPPORTED"));
                return;
            }

            navigator.geolocation.getCurrentPosition(
                (position) => {
                    resolve({
                        lat: position.coords.latitude,
                        long: position.coords.longitude,
                        systemName
                    });
                },
                (error) => {
                    console.error("Location Error:", error);

                    if (error.code === error.PERMISSION_DENIED) {
                        showErrorToast(
                            "Location permission denied. Please enable location access and try again."
                        );
                    } else if (error.code === error.POSITION_UNAVAILABLE) {
                        showErrorToast(
                            "Unable to get your location. Please enable your device location."
                        );
                    } else if (error.code === error.TIMEOUT) {
                        showErrorToast(
                            "Location request timed out. Please try again."
                        );
                    } else {
                        showErrorToast(
                            "Unable to get your location. Please try again."
                        );
                    }

                    reject(error);
                },
                {
                    enableHighAccuracy: true,
                    timeout: 10000,
                    maximumAge: 0
                }
            );
        });
    };
    const parseDataParts = (rawData: string) => {
        const dataParts: Record<string, string> = {};
        const matches = rawData.match(/(\w+):(.*?)(?=,\s*\w+:|$)/g);
        matches?.forEach((item) => {
            const index = item.indexOf(":");
            const key = item.substring(0, index).trim();
            const value = item.substring(index + 1).trim();
            dataParts[key] = value;
        });
        return dataParts;
    };

    const resolveUserType = (dataParts: Record<string, string>) => {
        if (dataParts.UserType === "Admin" || dataParts.UserType === "Processer" || dataParts.UserType === "Processor") {
            return dataParts.UserType;
        } else if (dataParts.UserType === "User" && dataParts.Approver.length > 0) {
            return "Requester";
        } else if (dataParts.UserType === "User") {
            return "Approver";
        }
        return "";
    };

    const storeUserDetails = (dataParts: Record<string, string>) => {
        localStorage.setItem("approver", dataParts.Approver);
        localStorage.setItem("maxofRec", dataParts.MaxofRec);
        localStorage.setItem("cardCode", dataParts.CardCode);
        localStorage.setItem("cardName", dataParts.CardName);
        localStorage.setItem("themeColor", dataParts.ThemeColor);
    };

    // Everything that used to run right after a successful login lives here,
    // so it can run after either the password step or the OTP step.
    const proceedAfterLogin = async (resolvedUserType: string, responseData: any) => {
        localStorage.setItem("userType", resolvedUserType);
        if (resolvedUserType === "Requester") {
            try {
                const responses = await axios.post('/Services/UserService.svc/TransServerClick', { userName });
                const result = responses.data;
                if (result !== null) {
                    showConfirmationDialog(result.Data, () => {
                        showSuccessToast(responseData.Message);
                        const allowedMenus = getFilteredMenuData(resolvedUserType);
                        const firstPath = allowedMenus[0]?.subMenu?.[0]?.path;
                        router.push(firstPath);
                        setConfirmationOpen(false);
                    });
                } else {
                    showSuccessToast(responseData.Message);
                    const allowedMenus = getFilteredMenuData(resolvedUserType);
                    const firstPath = allowedMenus[0]?.subMenu?.[0]?.path;
                    router.push(firstPath);
                }
            } catch (error) {
                console.error(error);
                showErrorToast("Something went wrong, please try again.");
            }
        } else {
            showSuccessToast(responseData.Message);
            const allowedMenus = getFilteredMenuData(resolvedUserType);
            const firstPath = allowedMenus[0]?.subMenu?.[0]?.path;
            router.push(firstPath);
        }
    };
    const GenerateOTP = (): string => {
        const characters = "1234567890";
        let otp = '';
        for (let i = 0; i < 6; i++) {
            const index = Math.floor(Math.random() * characters.length);
            otp += characters[index];
        }
        return otp;
    };

    const sendOtp = async (userId: string, mobileNo: string) => {
        try {
            const deviceInfo = await getDeviceLocation();
            const otp = GenerateOTP();
            const response = await axios.post("/Services/UserService.svc/OTPRequest", {
                UserId: userId,
                UserName: userName,
                Password: password,
                MobileNo: mobileNo,
                OTP: otp,
                SystemName: deviceInfo.systemName,
                Lat: deviceInfo.lat.toString(),
                Long: deviceInfo.long.toString(),

                // Lat: "13.025319008619512",
                // Long: "80.1997008548904",

            });
            debugger
            if (response.data.ErrorCode === 200) {
                return true;
            }
            showErrorToast(`Could not send OTP: ${response.data.Message || "Please try again."}`);
            return false;
        } catch (err) {
            showErrorToast("Something went wrong while sending the OTP. Please try again.");
            return false;
        }
    };

    // STEP 1: username only -> check whether OTP is required for this user.
    const handleUsernameSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!userName.trim()) {
            setErrors({ userName: 'Username is required' });
            return;
        }
        setErrors({});
        setLoading(true);
        try {
            const deviceInfo = await getDeviceLocation();
            localStorage.setItem('userName', userName);
            const response = await axios.post("/Services/UserService.svc/LoginUser", {
                userName,
                password: '',
                type: "UserDetails"
            });
            const responseData = response.data;

            if (responseData.ErrorCode !== 200) {
                showErrorToast(`${responseData.Message || "Unable to find this user."}`);
                return;
            }

            const dataParts = parseDataParts(responseData.Data as string);
            debugger
            const resolvedUserType = resolveUserType(dataParts);
            storeUserDetails(dataParts);
            debugger
            if (dataParts.OTPRequired === "Y") {

                const userId = dataParts.UserId || "";
                const mobileNo = dataParts.MobileNo || "";

                // Mobile number validation
                if (!mobileNo) {
                    showErrorToast("Mobile number is not available. Please contact admin.");
                    return;
                }

                // If multiple mobile numbers are returned
                // Adjust separators based on your API response format
                const mobileNumbers = mobileNo
                    .split(/[,;|]/)
                    .map((num: string) => num.trim())
                    .filter(Boolean);

                if (mobileNumbers.length !== 1) {
                    showErrorToast("Multiple mobile numbers found. Please contact admin.");
                    return;
                }

                // Exactly 10 digits validation
                if (!/^\d{10}$/.test(mobileNumbers[0])) {
                    showErrorToast("Invalid mobile number. Please contact admin.");
                    return;
                }

                const otpSent = await sendOtp(userId, mobileNo);

                const UserId = Number(userId);
                try {
                    const responseSMSRowData = await axios.post('/Services/UserService.svc/GetSingleSMSRow', { UserId });
                    debugger
                    if (responseSMSRowData.data.Message !== null) {
                        setPendingLogin({ resolvedUserType, responseData, userId, mobileNo });
                        setStep('otp');
                    }
                    else {
                        showErrorToast('Error occurred while sending SMS.');
                        if (!responseSMSRowData) return;
                    }

                } catch (smsError) {
                    console.log("Error occurred while sending SMS.");
                    throw smsError;
                }


            } else {
                // OTP not required -> now ask for the password.
                setStep('password');
            }
        } catch (err) {
            showErrorToast("Something went wrong. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    // STEP 2a: password path (only reached when OTP is NOT required).
    const handlePasswordSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!password.trim()) {
            setErrors((prev) => ({ ...prev, password: 'Password is required' }));
            return;
        }
        setLoading(true);
        try {
            const response = await axios.post("/Services/UserService.svc/LoginUser", {
                userName,
                password,
                type: "Login"
            });
            const responseData = response.data;

            if (responseData.ErrorCode !== 200) {
                showErrorToast(`Login failed: ${responseData.Message || "Please try again later."}`);
                return;
            }

            const dataParts = parseDataParts(responseData.Data as string);
            const resolvedUserType = resolveUserType(dataParts);
            storeUserDetails(dataParts);

            await proceedAfterLogin(resolvedUserType, responseData);
        } catch (err) {
            showErrorToast("Something went wrong. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    // STEP 2b: OTP path (only reached when OTP IS required) — verifying the
    // OTP is treated as the login itself, so no password is ever asked for.
    const handleOtpSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!otp.trim()) {
            setErrors((prev) => ({ ...prev, otp: 'OTP is required' }));
            return;
        }
        if (!pendingLogin) return;

        setOtpLoading(true);
        try {
            const response = await axios.post("/Services/UserService.svc/OTPVerification", {
                EnteredOTP: otp,
                MobileNo: pendingLogin.mobileNo,
                UserName: userName,
            });

            if (response.data.ErrorCode === 200) {
                const { resolvedUserType, responseData } = pendingLogin;
                setOtp('');
                setPendingLogin(null);
                await proceedAfterLogin(resolvedUserType, responseData);
            } else {
                showErrorToast(`OTP verification failed: ${response.data.Message || "Please try again."}`);
            }
        } catch (err) {
            showErrorToast("Something went wrong while verifying OTP. Please try again.");
        } finally {
            setOtpLoading(false);
        }
    };

    const handleResendOtp = async () => {
        if (!pendingLogin) return;
        setResendLoading(true);
        const sent = await sendOtp(pendingLogin.userId, pendingLogin.mobileNo);
        if (sent) {
            showSuccessToast("OTP resent successfully.");
        }
        setResendLoading(false);
    };

    const resetToUsernameStep = () => {
        setStep('username');
        setPassword('');
        setOtp('');
        setPendingLogin(null);
        setErrors({});
    };


    return (
        <div
            style={{
                background: themeColor,
            }}
            className="flex items-center justify-center min-h-screen"
        >
            {step === 'username' && (
                <form
                    onSubmit={handleUsernameSubmit}
                    className="w-full max-w-md p-10 bg-white rounded-2xl shadow-2xl"
                >
                    <div className="flex justify-center items-center">
                        <img className="w-20 h-20" src="/SathyaLogo.png" alt="SATHYA" width={80} height={80} />
                    </div>
                    <h2 className="text-3xl font-bold text-center text-red-700 mb-8">User Login</h2>

                    <div className="relative mb-6">
                        <TextField
                            fullWidth
                            label="Username"
                            variant="outlined"
                            value={userName}
                            onChange={(e) => setUserName(e.target.value)}
                            error={!!errors.userName}
                            helperText={errors.userName}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <FaUser className="text-gray-600" />
                                    </InputAdornment>
                                ),
                                style: { backgroundColor: "#ffffff" },
                            }}
                        />
                    </div>

                    <Button
                        type="submit"
                        variant="contained"
                        fullWidth
                        size="large"
                        className="rounded-xl shadow-md"
                        style={{ background: themeColor }}
                        disabled={loading}
                    >
                        {loading ? <CircularProgress size={24} color="inherit" /> : "Continue"}
                    </Button>
                </form>
            )}

            {step === 'password' && (
                <form
                    onSubmit={handlePasswordSubmit}
                    className="w-full max-w-md p-10 bg-white rounded-2xl shadow-2xl"
                >
                    <div className="flex justify-center items-center">
                        <img className="w-20 h-20" src="/SathyaLogo.png" alt="SATHYA" width={80} height={80} />
                    </div>
                    <h2 className="text-3xl font-bold text-center text-red-700 mb-2">Enter Password</h2>
                    <p className="text-center text-gray-500 text-sm mb-6">Logging in as {userName}</p>

                    <div className="relative mb-6">
                        <TextField
                            fullWidth
                            label="Password"
                            type={showPassword ? "text" : "password"}
                            variant="outlined"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            error={!!errors.password}
                            helperText={errors.password}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <FaLock className="text-gray-600" />
                                    </InputAdornment>
                                ),
                                endAdornment: (
                                    <InputAdornment position="end" onClick={() => setShowPassword(!showPassword)} style={{ cursor: "pointer" }}>
                                        {showPassword ? <FaEye /> : <FaEyeSlash />}
                                    </InputAdornment>
                                ),
                                style: { backgroundColor: "#ffffff" },
                            }}
                        />
                    </div>

                    <Button
                        type="submit"
                        variant="contained"
                        fullWidth
                        size="large"
                        className="rounded-xl shadow-md"
                        style={{ background: themeColor }}
                        disabled={loading}
                    >
                        {loading ? <CircularProgress size={24} color="inherit" /> : "Login"}
                    </Button>

                    <Button fullWidth size="small" className="mt-3" onClick={resetToUsernameStep}>
                        Back
                    </Button>
                </form>
            )}

            {step === 'otp' && (
                <form
                    onSubmit={handleOtpSubmit}
                    className="w-full max-w-md p-10 bg-white rounded-2xl shadow-2xl"
                >
                    <div className="flex justify-center items-center">
                        <img className="w-20 h-20" src="/SathyaLogo.png" alt="SATHYA" width={80} height={80} />
                    </div>
                    <h2 className="text-3xl font-bold text-center text-red-700 mb-2">Enter OTP</h2>
                    <p className="text-center text-gray-500 text-sm mb-6">
                        An OTP has been sent to your registered mobile number.
                    </p>

                    <div className="relative mb-6">
                        <TextField
                            fullWidth
                            label="OTP"
                            variant="outlined"
                            value={otp}
                            onChange={(e) => setOtp(e.target.value)}
                            error={!!errors.otp}
                            helperText={errors.otp}
                            InputProps={{ style: { backgroundColor: "#ffffff" } }}
                        />
                    </div>

                    <Button
                        type="submit"
                        variant="contained"
                        fullWidth
                        size="large"
                        className="rounded-xl shadow-md"
                        style={{ background: themeColor }}
                        disabled={otpLoading}
                    >
                        {otpLoading ? <CircularProgress size={24} color="inherit" /> : "Verify OTP"}
                    </Button>
                </form>
            )}

            {/* Confirmation Dialog */}
            {confirmationOpen && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
                    onClick={() => setConfirmationOpen(false)}
                >
                    <div className="bg-white rounded p-6 w-[700px]" onClick={(e) => e.stopPropagation()}>
                        <p className="mb-4">{confirmationMessage}</p>
                        <div className="flex justify-end gap-4">
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                    if (onConfirm) onConfirm();
                                }}
                            >
                                OK
                            </Button>
                        </div>
                    </div>
                </div>
            )}
            <ToastContainer />
        </div>
    );
};

export default LoginForm;